import React, { useEffect, useRef } from "react";

/** Mini route map for the publish page (replaces the wireframe's static raster). */
export default function RouteMap({ from, to, trucks, onPick }) {
  const el = useRef(null);
  const map = useRef(null);
  const objs = useRef([]);

  useEffect(() => {
    let tries = 0;
    const draw = () => {
      const g = window.google;
      if (!g || !g.maps || !el.current) {
        if (tries++ < 20) setTimeout(draw, 500);
        return;
      }
      if (!map.current) {
        map.current = new g.maps.Map(el.current, {
          center: { lat: 45, lng: 70 },
          zoom: 3,
          disableDefaultUI: true,
          clickableIcons: false,
          gestureHandling: "cooperative",
        });
      }
      objs.current.forEach((o) => o.setMap(null));
      objs.current = [];
      const pts = [from, to].filter((p) => p && p.lat != null && p.lng != null);
      const tpts = (trucks || []).filter((t) => t && t.lat != null && t.lng != null);
      if (!pts.length && !tpts.length) return;
      const b = new g.maps.LatLngBounds();
      // free trucks as green dots (click = pick it)
      tpts.forEach((t) => {
        const pos = { lat: Number(t.lat), lng: Number(t.lng) };
        b.extend(pos);
        const m = new g.maps.Marker({
          map: map.current,
          position: pos,
          title: t.title || "",
          icon: { path: g.maps.SymbolPath.CIRCLE, scale: 7, fillColor: "#16a34a", fillOpacity: 1, strokeColor: "#fff", strokeWeight: 2 },
        });
        if (onPick) m.addListener("click", () => onPick(t));
        objs.current.push(m);
      });
      // a single spot (or several trucks on the very same point) must not zoom to street level
      const capZoom = () => g.maps.event.addListenerOnce(map.current, "idle", () => map.current.getZoom() > 10 && map.current.setZoom(10));
      if (!pts.length) {
        map.current.fitBounds(b, 40);
        capZoom();
        return;
      }
      pts.forEach((p, i) => {
        const pos = { lat: Number(p.lat), lng: Number(p.lng) };
        b.extend(pos);
        objs.current.push(
          new g.maps.Marker({
            map: map.current,
            position: pos,
            label: { text: i === 0 && pts.length === 2 || p === from ? "A" : "B", color: "#fff", fontSize: "11px" },
          }),
        );
      });
      if (pts.length === 2) {
        objs.current.push(
          new g.maps.Polyline({
            map: map.current,
            path: pts.map((p) => ({ lat: Number(p.lat), lng: Number(p.lng) })),
            strokeColor: "#0063ff",
            strokeOpacity: 0.8,
            strokeWeight: 3,
            geodesic: true,
          }),
        );
        map.current.fitBounds(b, tpts.length ? 50 : 30);
      } else if (tpts.length) {
        map.current.fitBounds(b, 50);
      } else {
        map.current.setCenter({ lat: Number(pts[0].lat), lng: Number(pts[0].lng) });
        map.current.setZoom(6);
      }
    };
    draw();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [from, to, trucks]);

  return <div ref={el} className="map-art" style={{ position: "absolute", inset: 0, background: "#e5f3ed" }} />;
}
